
import {
  LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Line, ResponsiveContainer, RadialBarChart, RadialBar, PolarAngleAxis,
} from 'recharts';
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";

import { Box, Flex } from "@chakra-ui/react";
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useDispatch, useSelector, } from 'react-redux';
import { getStates, getMarketSizeAnalysis } from '../../actions/sector/sectorActions';
import { useParams } from "react-router-dom";
import ImportData from './ImportData';
import GlobalExport from './GlobalExport';
import ExportDataGraph from './ExportDataGraph';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerCloseButton,
  Button,
  useDisclosure,
  Spinner,
  Text
} from "@chakra-ui/react";
import { color } from 'framer-motion';



const CategorySize = ({ regionsData, statesData }) => {
  const dispatch = useDispatch();


  const [hasHydrated, setHasHydrated] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState(["fruits & nuts"]);
  const [selectedRegionsList, setSelectedRegionsList] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState(["urban", "rural"]);
  const [fractileRange, setFractileRange] = useState([20, 100]);
  const [toggleAllItems, setToggleAllItems] = useState(false);
  const [toggleItems, setToggleItems] = useState(false);
  const [productGraphs, setProductGraphs] = useState([]);

  const [chartData, setChartData] = useState([]);
  const [displayedMpceFromFractile, setDisplayedMpceFromFractile] = useState(null);
  const [displayedExpenditurePercentage, setDisplayedExpenditurePercentage] = useState(null);
  const [selectedStates, setSelectedStates] = useState({ "Andhra Pradesh": { urban: true, rural: true } });

  const categoryKeyMap = useMemo(() => ({
    "durable goods": { sector: "Furniture and Fixtures, Electronic & Other Electrical Equipment & Components" },
    "egg, fish & meat": { sector: "Food and Kindred Products" },
    "vegetables": { sector: "Food and Kindred Products" },
    "milk & milk products": { sector: "Food and Kindred Products" },
    "edible oil": { sector: "Food and Kindred Products" },
    "medical": { sector: "Health Services" },
    "education": { sector: "Educational Services" },
    "consumer services excluding conveyance": { sector: "Personal Services" },
    "pulses & their products": { sector: "Food and Kindred Products" },
    "sugar, salt and spices": { sector: "Food and Kindred Products" },
    "pan, tobacco & intoxicants": { sector: "Tobacco Products" },
    "cereals & cereal substitutes": { sector: "Food and Kindred Products" },
    "beverages, refreshments & processed food": { sector: "Food and Kindred Products" },
    "clothing, bedding & footwear": { sector: "Apparel, Finished Products from Fabrics & Similar Materials" },
    "fruits & nuts": { sector: "Food and Kindred Products" },
    "fuel and light": { sector: "Petroleum Refining and Related Industries" },
    "misc. goods & services": { sector: "Miscellaneous Manufacturing Industries" },
    "conveyance": { sector: "Transportation Services" },
    "gram": { sector: "Food and Kindred Products" }
  }), []);
  const { sectorId } = useParams();
  const [min, max] = fractileRange;
  const categorySize = useSelector(state => state.categorySizeReducer) || {};
  const regionsFromStore = useSelector(state => state.categorySizeReducer.regions?.data || []);
  const marketSizeAnalysis = categorySize.marketSizeAnalysis || {};
  const marketSizeData = categorySize?.marketSizeAnalysis?.data || [];
  ;

  const loading = categorySize.loading;
  const states = categorySize.states?.data || [];
  const regions = categorySize.regions?.data || [];
  const [selectedProduct, setSelectedProduct] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [activeCategories, setActiveCategories] = useState({
    "fruits & nuts": true,
    "pulses & their products": true,
    "fuel and light": true,
    "medical": true,
    "gram": true,
    "vegetables": true,
    "consumer services excluding conveyance": true,
    "conveyance": true,
    "cereals & cereal substitutes": true,
    "pan, tobacco & intoxicants": true,
    "egg, fish & meat": true,
    "sugar, salt and spices": true,
    "clothing, bedding & footwear": true,
    "education": true,
    "edible oil": true,
    "milk & milk products": true,
    "rent": true,
    "durable goods": true,
    "taxes and cesses": true,
    "misc. goods & services": true,
    "beverages, refreshments & processed food": true,
  });

  
const { data } = useSelector((state) => state.sectorSmmReducer);
console.log("Full sector data:", data);

// Get sector name from the first item's linkedSIC2.name
const sectorName = data && data.length > 0 
  ? data[0]?.linkedSIC2?.name || "Sector Name Not Available"
  : "Loading sectors...";

console.log("Sector Name to display:", sectorName);
  const trimmedActiveCategories = {};
  Object.keys(activeCategories).forEach(cat => {
    const trimmedCat = cat.replace(/[^a-zA-Z\s]/g, '').trim();
    trimmedActiveCategories[trimmedCat] = activeCategories[cat];
  });

  const sectorWiseCategories = {};

  Object.keys(trimmedActiveCategories).forEach(cat => {
    if (trimmedActiveCategories[cat]) {
      const sector = categoryKeyMap[cat]?.sector || 'Unknown';

      if (!sectorWiseCategories[sector]) {
        sectorWiseCategories[sector] = [];
      }

      sectorWiseCategories[sector].push(
        cat.charAt(0).toUpperCase() + cat.slice(1).toLowerCase()
      );
    }
  });

  const categories = useMemo(() => {
    return Object.keys(activeCategories).filter(cat => {
      const sectorStr = categoryKeyMap[cat]?.sector || "";
      return activeCategories[cat] && sectorStr.split(/\s*,\s*/).includes(sectorName);
    });
  }, [activeCategories, sectorName]);



  Object.keys(trimmedActiveCategories).forEach(cat => {
    if (trimmedActiveCategories[cat]) {  // Only include active ones
      const sector = categoryKeyMap[cat]?.sector || 'Unknown';
      if (!sectorWiseCategories[sector]) {
        sectorWiseCategories[sector] = [];
      }
      sectorWiseCategories[sector].push(
        cat.charAt(0).toUpperCase() + cat.slice(1).toLowerCase()
      );
    }
  });


  useEffect(() => {
    dispatch(getStates());
  }, [dispatch]);

  useEffect(() => {
    const activeStates = Object.entries(selectedStates)
      .filter(([_, selections]) => selections.urban || selections.rural)
      .map(([stateName, _]) => stateName);

    const activeRegions = [];
    Object.values(selectedStates).forEach(selections => {
      if (selections.urban) activeRegions.push('urban');
      if (selections.rural) activeRegions.push('rural');
    });

    const payload = {
      states: activeStates.length > 0 ? activeStates : [],
      regions: activeRegions.length > 0 ? [...new Set(activeRegions)] : [],
      fractileRange
    };

    if (selectedCategories.length > 0) {
      payload.categories = selectedCategories;
    }
    dispatch(getMarketSizeAnalysis(payload));
  }, [selectedCategories, selectedStates, fractileRange, dispatch, sectorId]);

  const shouldShowMap = selectedCategories.length > 0 &&
    Object.values(selectedStates).some(sel => sel.urban || sel.rural) &&
    selectedRegions.length > 0;

  function transformMarketSizeData(
    data,
    selectedStates = [],
    selectedRegions = [],
    selectedCategories = [],
    fractileRange = null
  ) {
    if (!Array.isArray(data) || data.length === 0) return [];

    const normalizedStates = selectedStates.map(s => s.toLowerCase());
    const normalizedRegions = selectedRegions.map(r => r.toLowerCase());
    const normalizedCategories = selectedCategories.map(c => c.toLowerCase());

    const filteredData = data.filter(item => {
      const state = item.state?.toLowerCase();
      const region = item.region?.toLowerCase();
      const category = item.category?.toLowerCase();
      const year = item.year;
      const fractileClass = item.fractile_class;

      const matchesState = normalizedStates.length === 0 || normalizedStates.includes(state);
      const matchesRegion = normalizedRegions.length === 0 || normalizedRegions.includes(region);
      const matchesCategory = normalizedCategories.length === 0 || normalizedCategories.includes(category);
      const matchesYear = year >= 1999 && year <= 2023;
      const matchesFractile =
        !fractileRange || fractileClass === undefined || fractileClass === null || (
          fractileClass >= fractileRange[0] && fractileClass <= fractileRange[1]
        );

      const isIncluded = matchesState && matchesRegion && matchesCategory && matchesYear && matchesFractile;

      if (!isIncluded) {
        // console.log('Filtered out:', {
        //   state, region, category, year, fractileRange,
        //   matchesState, matchesRegion, matchesCategory, matchesYear, matchesFractile
        // });
      }

      return isIncluded;
    });

    // console.log('Filtered Data:', filteredData.length, filteredData);

    const result = {};

    filteredData.forEach(item => {
      const year = item.year;
      const category = item.category;

      if (!result[year]) {
        result[year] = { year };
      }
      if (!result[year][category]) {
        result[year][category] = 0;
      }

      const marketSizeValue = item.marketSize ?? item.marketsize ?? 0;
      result[year][category] += marketSizeValue;
    });

    const finalResult = Object.values(result).sort((a, b) => a.year - b.year);
    // console.log('Transformed Result:', finalResult);
    return finalResult;
  }

  useEffect(() => {
    if (marketSizeData && Array.isArray(marketSizeData)) {
      const transformedData = transformMarketSizeData(
        marketSizeData,
        Object.keys(selectedStates).filter(state => {
          const sel = selectedStates[state];
          return sel.urban || sel.rural;
        }),
        selectedRegions,
        selectedCategories,
        fractileRange
      );
      setChartData(transformedData);
      // console.log("Transformed Chart Data:", transformedData);
    } else {
      setChartData([]);
    }
  }, [marketSizeData, selectedStates, selectedCategories, selectedRegions, fractileRange]);


  // console.log("sectorWiseCategories:", sectorWiseCategories);
  const handleAllItemsToggle = () => {
    if (toggleAllItems) {
      setSelectedCategories([]);
    } else {
      setSelectedCategories([...categories]);
    }
    setToggleAllItems(!toggleAllItems);
  };


  const handleCategorySelect = (cat) => {
    setSelectedCategories(prev =>
      prev.includes(cat)
        ? prev.filter(c => c !== cat)
        : [...prev, cat]
    );
  };


  useEffect(() => {
    setToggleAllItems(selectedCategories.length === categories.length);
  }, [selectedCategories, categories]);

  const handleStateToggle = (stateName, type) => {
    setSelectedStates(prev => ({
      ...prev,
      [stateName]: {
        ...prev[stateName],
        [type]: !prev[stateName]?.[type]

      }
    }));
  };

  const handlePanItemsToggle = () => {
    const newToggleState = !toggleItems;
    setToggleItems(newToggleState);

    if (newToggleState) {
      const allStatesSelected = {};
      states.forEach(state => {
        allStatesSelected[state] = { urban: true, rural: true };
      });
      setSelectedStates(allStatesSelected);
    } else {
      const noneSelected = {};
      states.forEach(state => {
        noneSelected[state] = { urban: false, rural: false };
      });
      setSelectedStates(noneSelected);
    }
  };


  const allowedSteps = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

  const snapToStep = (value) => {
    return allowedSteps.reduce((prev, curr) =>
      Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev
    );
  };


  const step = 10;



  const handleFractileSlider = (index, value) => {
    let val = Math.round(Number(value) / step) * step;

    setFractileRange(prev => {
      const newRange = [...prev];
      newRange[index] = val;
      return newRange;
    });
  };


  const categoryColors = {
    "fruits & nuts": "#FF6384",
    "pulses & their products": "#36A2EB",
    "fuel and light": "#FFCE56",
    "medical": "#4BC0C0",
    "gram": "#9966FF",
    "vegetables": "#FF9F40",
    "consumer services excluding conveyance": "#FFCD56",
    "conveyance": "#C9CBCF",
    "cereals & cereal substitutes": "#2ecc71",
    "pan, tobacco & intoxicants": "#e74c3c",
    "egg, fish & meat": "#3498db",
    "sugar, salt and spices": "#f39c12",
    "clothing, bedding & footwear": "#9b59b6",
    "education": "#34495e",
    "edible oil": "#e67e22",
    "milk & milk products": "#1abc9c",
    "rent": "#7f8c8d",
    "durable goods": "#d35400",
    "taxes and cesses": "#bdc3c7",
    "misc. goods & services": "#8e44ad",
    "beverages, refreshments & processed food": "#16a085"
  };

  const formatMarketSize = (value) => {
    if (value >= 1000000000000) {
      return `₹${(value / 1000000000000).toFixed(2)}T`;
    }
    if (value >= 1000000000) {
      return `₹${(value / 1000000000).toFixed(2)}B`;
    }
    if (value >= 1000000) {
      return `₹${(value / 1000000).toFixed(2)}M`;
    }
    if (value >= 1000) {
      return `₹${(value / 1000).toFixed(2)}K`;
    }
    return `₹${Math.round(value)}`;
  };
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          padding: 10,
          boxShadow: "0 0 10px rgba(0,0,0,0.1)"
        }}>
          <p><strong>Year:</strong> {label}</p>
          {payload.map((item, index) => (
            <p key={index} style={{ color: item.color }}>
              <strong>{item.name}:</strong> {formatMarketSize(item.value)}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  const anyCategoriesSelected = selectedCategories.length > 0;
  const isPanIndiaMode = toggleItems;

  const canShowPanIndiaBreakdown = anyCategoriesSelected && isPanIndiaMode;

  useEffect(() => {
    if (data?.fractileInfo?.originalFractileMPCEByYearState) {
      const fractileDb = data.fractileInfo.originalFractileMPCEByYearState;
      const yearToUse = "1999";

      let lookupStateName = "ALL_INDIA";
      const activeSelectedStates = Object.entries(selectedStates)
        .filter(([_, selections]) => selections.urban || selections.rural)
        .map(([stateName, _]) => stateName);

      if (!toggleItems && activeSelectedStates.length === 1) {
        lookupStateName = activeSelectedStates[0];
      }
      let lookupRegionKeyForMpce = null;
      const hasUrbanSelected = Object.values(selectedStates).some(s => s.urban);
      const hasRuralSelected = Object.values(selectedStates).some(s => s.rural);

      if (toggleItems) {
        lookupRegionKeyForMpce = fractileDb[yearToUse]?.[lookupStateName]?.rural ? 'rural' :
          fractileDb[yearToUse]?.[lookupStateName]?.urban ? 'urban' :
            fractileDb[yearToUse]?.[lookupStateName]?.both ? 'both' : null;
      } else {
        if (hasUrbanSelected && hasRuralSelected) {
          lookupRegionKeyForMpce = fractileDb[yearToUse]?.[lookupStateName]?.both ? 'both' : null;
        } else if (hasUrbanSelected) {
          lookupRegionKeyForMpce = 'urban';
        } else if (hasRuralSelected) {
          lookupRegionKeyForMpce = 'rural';
        }
      }

      if (fractileDb[yearToUse]?.[lookupStateName]?.[lookupRegionKeyForMpce]) {
        const regionData = fractileDb[yearToUse][lookupStateName][lookupRegionKeyForMpce];
        const fractileRangeKey = `${min}-${max}%`;
        const mpceValue = regionData[fractileRangeKey];
        setDisplayedMpceFromFractile(mpceValue !== undefined ? mpceValue : null);
      } else {
        setDisplayedMpceFromFractile(null);
      }
    } else {
      setDisplayedMpceFromFractile(null);
    }
  }, [data, min, max, selectedStates, toggleItems]);


  useEffect(() => {
    if (data?.percentageExpenditureByCategory) {
      const firstSelectedCategory = selectedCategories[0];
      if (firstSelectedCategory) {
        const backendKey = categoryKeyMap[firstSelectedCategory];
        if (backendKey && data.percentageExpenditureByCategory[backendKey]) {
          const expenditureForYear = data.percentageExpenditureByCategory[backendKey]["1999"];
          setDisplayedExpenditurePercentage(expenditureForYear !== undefined ? expenditureForYear : null);
        } else {
          setDisplayedExpenditurePercentage(null);
        }
      } else {
        setDisplayedExpenditurePercentage(null);
      }
    } else {
      setDisplayedExpenditurePercentage(null);
    }
  }, [data, selectedCategories]);




  const exportMarkets = [
    { country: 'Australia', value: 100 },
    { country: 'Turkey', value: 85 },
    { country: 'US', value: 50 },
    { country: 'Singapore', value: 30 },
    { country: 'Maldives', value: 20 },
    { country: 'UK', value: 10 },
  ];

  const globalExports = [
    { product: 'Product 1', quantity: 82324, value: 285.92 },
    { product: 'Product 2', quantity: 62097, value: 282.05 },
    { product: 'Product 3', quantity: 74012, value: 276.19 },
    { product: 'Product 4', quantity: 64311, value: 270.02 },
    { product: 'Product 5', quantity: 45789, value: 250.15 },
  ];

  const maxValue = Math.max(...exportMarkets.map(m => m.value));

  const [openRegion, setOpenRegion] = useState(null); // track which region is open

  const toggleRegion = (region) => {
    setOpenRegion(openRegion === region ? null : region);
  };


  const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '3px',
    },
    section: {
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '20px',
    },
    sectionTitle: {
      fontSize: '14px',
      fontWeight: '600',
      marginBottom: '16px',
      color: '#5D5D5D',
    },
    filterGroup: {
      marginBottom: '24px',
    },
    filterTitle: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
      fontWeight: '600',
      marginBottom: '12px',
    },
    chipGroup: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
    },
    chip: {
      padding: '6px 12px',
      borderRadius: '16px',
      fontSize: '14px',
      cursor: 'pointer',
      border: 'none',
    },
    activeChip: {
      backgroundColor: '#30D5C8',
      color: '#000',
      borderRadius: '10px',
      fontWeight: '600',
    },
    inactiveChip: {
      backgroundColor: '#e0e0e0',
      color: '#000',
      borderRadius: '10px',

    },
    regionTable: {
      width: '100%',
      borderCollapse: 'collapse',
      color: '#30D5C8',
      fontWeight: '600',
      textTransform: 'uppercase'
    },
    tableHeader: {
      textAlign: 'left',
      padding: '8px',
      fontSize: '14px',
      color: '#666',
    },
    tableCell: {
      padding: '8px',
      fontSize: '14px',
    },
    checkbox: {
      width: '18px',
      height: '18px',
      backgroundColor: '#5D5D5D'
    },
    formula: {
      backgroundColor: '#ADECFF',
      padding: '16px',
      borderRadius: '8px',
    },
    formulaTitle: {
      fontSize: '14px',
      fontWeight: '600',
      marginBottom: '12px',
    },
    formulaItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '6px 6px',
      backgroundColor: 'white',
      borderRadius: '4px',
      marginBottom: '8px',
    },
    closeButton: {
      padding: '2px 6px',
      backgroundColor: '#ddd',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    barChart: {
      width: '100%',
      marginTop: '16px',
    },
    bar: {
      height: '24px',
      backgroundColor: '#d4d6ff',
      marginBottom: '8px',
    },
    sliderWrapper: {
      position: 'relative',
      height: '30px',
      marginBottom: '10px',
    },
    rangeTrack: {
      position: 'absolute',
      top: '74%',
      left: '0',
      width: '100%',
      height: '4px',
      backgroundColor: '#ddd',
      transform: 'translateY(-50%)',
      borderRadius: '2px',
    },
    rangeFill: {
      position: 'absolute',
      top: '70%',
      height: '4px',
      backgroundColor: '#444',
      borderRadius: '2px',
      transform: 'translateY(-50%)',
    },
    slider: {
      WebkitAppearance: 'none',
      appearance: 'none',
      width: '100%',
      height: '30px',
      background: 'transparent',
      position: 'absolute',
      top: 0,
      pointerEvents: 'none',
    },
    formulaRowGroup: {
      display: 'flex',
      gap: '8px',
      flexWrap: 'nowrap',
    },
    barLabel: {
      display: "flex",
    },
    marketSizeContainer: {
      marginTop: '20px',
      padding: '15px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px'
    },
    marketSizeItem: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '10px'
    },
    marketSizeLabel: {
      fontWeight: '600'
    },
    chartContainer: {
      padding: '20px',
      textAlign: 'center',
      color: '#666'
    }
  };
  useEffect(() => {
    console.log("Chart Data:", chartData);
  }, [chartData]);


  const normalizeKey = (str) => str.toLowerCase().trim();

  const normalizedChartData = chartData.map(entry => {
    const newEntry = { year: entry.year };
    Object.keys(entry).forEach(key => {
      if (key !== "year") {
        newEntry[normalizeKey(key)] = entry[key];
      }
    });
    return newEntry;
  });


  const normalizedSectorName = sectorName?.trim().toLowerCase();

  // Normalize sectorWiseCategories keys
  const normalizedSectorWiseCategories = {};
  Object.keys(sectorWiseCategories).forEach(key => {
    normalizedSectorWiseCategories[key.trim().toLowerCase()] = sectorWiseCategories[key];
  });

  const statesByRegion = categorySize.states?.data || {};
  const loadingStates = categorySize.states?.loading; // assuming your reducer has `loading`



  return (
    <>
      {/* Top Section */}
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="flex-start"
        align="flex-start"
        w="100%"
        p={3}
        gap={6}
      >
        <Box flex="1" maxW={{ base: "100%", md: "850px" }}>
          <ImportData
            sectorName={sectorName}
            sectorWiseCategories={normalizedSectorWiseCategories}
            categories={normalizedSectorWiseCategories[normalizedSectorName]}
          />
        </Box>

        {shouldShowMap && (
          <Box w="100%" mt={{ base: 6, md: 0 }}>
            {/* Header + Filters */}
            <Flex
              direction={{ base: "column", sm: "row" }}
              justify="space-between"
              align={{ base: "flex-start", sm: "center" }}
              gap={3}
              mb={3}
            >
              <Text fontSize="md" fontWeight="bold">
                Trend in percentage composition of MPCE since 1999-'00
              </Text>
              <Button
                onClick={onOpen}
                size="sm"
                bg="#30D5C8"
                color="white"
                _hover={{ bg: "#25b9ad" }}
                w={{ base: "100%", sm: "auto" }}
              >
                Apply Filters
              </Button>
            </Flex>

            {/* Chart Section */}
            <Box w="100%">
              {loading ? (
                <Flex justify="center" align="center" h="300px">
                  <Spinner size="xl" color="#30D5C8" />
                  <Text ml={3}>Loading market size data...</Text>
                </Flex>
              ) : chartData?.length > 0 && selectedCategories?.length > 0 ? (
                <ResponsiveContainer width="100%" height={380}>
                  <LineChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="year" />
                    <YAxis
                      tickFormatter={(value) =>
                        value != null ? formatMarketSize(value) : "-"
                      }
                    />
                    <Tooltip
                      content={<CustomTooltip />}
                      formatter={(value) =>
                        value != null ? formatMarketSize(value) : "-"
                      }
                    />
                    {selectedCategories.map((category) => {
                      const key = normalizeKey(category);
                      const hasData = chartData.some((item) => key in item);
                      return hasData ? (
                        <Line
                          key={category}
                          type="monotone"
                          dataKey={key}
                          stroke={categoryColors?.[category] || "#30D5C8"}
                          activeDot={{ r: 8 }}
                        />
                      ) : null;
                    })}
                  </LineChart>
                </ResponsiveContainer>
              ) : (
                <Text color="gray.500" fontSize="sm">
                  {selectedCategories?.length === 0
                    ? "Please select at least one category to view market size trends"
                    : "No data available for the selected filters"}
                </Text>
              )}
            </Box>

            {/* Drawer */}
            <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
              <DrawerContent
                maxW="670px"
                sx={{
                  marginTop: "120px",
                  marginLeft: "60px",
                  height: "calc(100% - 120px)",
                }}
                borderRadius="md"
                boxShadow="lg"
              >
                <DrawerCloseButton />
                <DrawerBody p={6}>

                  <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Set category sizing by applying filters</h2>
                    <div style={styles.filterGroup}>
                      <div
                        style={{
                          ...styles.filterTitle,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>ITEM CATEGORY</span>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <div
                            onClick={handleAllItemsToggle}
                            style={{
                              position: "relative",
                              width: "36px",
                              height: "20px",
                              backgroundColor: toggleAllItems ? "#4CAF50" : "#ccc",
                              borderRadius: "20px",
                              transition: "background-color 0.3s",
                              cursor: "pointer",
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                top: "2px",
                                left: toggleAllItems ? "18px" : "2px",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "#fff",
                                borderRadius: "50%",
                                transition: "left 0.3s",
                              }}
                            />
                          </div>
                          <span style={{ fontSize: "13px", color: "#888" }}>All Items</span>
                        </div>
                      </div>



                      <div style={styles.chipGroup}>
                        {categories.map(cat => (
                          <button
                            key={cat}
                            style={{
                              ...styles.chip,
                              ...(selectedCategories.includes(cat) ? styles.activeChip : styles.inactiveChip)
                            }}
                            onClick={() => handleCategorySelect(cat)}
                          >
                            {cat}
                          </button>
                        ))}
                      </div>
                    </div>


                    <div style={{ marginTop: "10px" }}>
                      {loadingStates ? (
                        <p>Loading states...</p>
                      ) : Object.keys(statesByRegion).length === 0 ? (
                        <p>No states data available.</p>
                      ) : (
                        Object.entries(statesByRegion).map(([region, statesList]) => (
                          <div key={region} style={{ marginBottom: "12px" }}>
                            {/* Region header */}
                            <div
                              onClick={() => toggleRegion(region)}
                              style={{
                                cursor: "pointer",
                                fontWeight: "600",
                                padding: "8px 12px",
                                backgroundColor: "#F8FDFD",
                                borderRadius: "4px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              {region}
                              {openRegion === region ? (
                                <ChevronUpIcon boxSize={6} color="#30D5C8" />
                              ) : (
                                <ChevronDownIcon boxSize={6} color="#30D5C8" />
                              )}
                            </div>
                            {/* States dropdown */}
                            {openRegion === region && (
                              <div style={{ maxHeight: "200px", overflowY: "auto", marginTop: "8px" }}>
                                <table style={styles.regionTable}>
                                  <thead>
                                    <tr>
                                      <th style={styles.tableHeader}>State</th>
                                      <th style={styles.tableHeader}>Urban</th>
                                      <th style={styles.tableHeader}>Rural</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {statesList.map((stateName) => (
                                      <tr key={stateName}>
                                        <td style={styles.tableCell}>{stateName}</td>
                                        <td style={styles.tableCell}>
                                          <input
                                            type="checkbox"
                                            checked={selectedStates[stateName]?.urban || false}
                                            onChange={() => handleStateToggle(stateName, "urban")}
                                            disabled={toggleItems}
                                            style={{ ...styles.checkbox, opacity: toggleItems ? 0.5 : 1 }}
                                          />
                                        </td>
                                        <td style={styles.tableCell}>
                                          <input
                                            type="checkbox"
                                            checked={selectedStates[stateName]?.rural || false}
                                            onChange={() => handleStateToggle(stateName, "rural")}
                                            disabled={toggleItems}
                                            style={{ ...styles.checkbox, opacity: toggleItems ? 0.5 : 1 }}
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        ))
                      )}
                    </div>





                    <div style={styles.filterTitle}>% Fractile classes</div>
                    {/* <div>
                      <div style={{ position: 'relative', height: '40px', width: '300px' }}>

                        <div
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: 0,
                            width: '100%',
                            height: '6px',
                            background: '#ddd',
                            borderRadius: '3px',
                            transform: 'translateY(-50%)',
                            zIndex: 0,
                          }}
                        />


                        <div
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: `${Math.min(fractileRange[0], fractileRange[1])}%`,
                            width: `${Math.abs(fractileRange[1] - fractileRange[0])}%`,
                            height: '6px',
                            background: '#FFAA00',
                            borderRadius: '3px',
                            transform: 'translateY(-50%)',
                            zIndex: 1,
                          }}
                        />


                        <input
                          type="range"
                          min={0}
                          max={100}
                          step={step}
                          value={fractileRange[0]}
                          onChange={e => handleFractileSlider(0, e.target.value)}
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            background: 'transparent',
                            zIndex: 3,
                            WebkitAppearance: 'none',
                            height: '40px',
                            pointerEvents: 'none',
                          }}
                        />

                        Upper thumb
                        <input
                          type="range"
                          min={0}
                          max={100}
                          step={step}
                          value={fractileRange[1]}
                          onChange={e => handleFractileSlider(1, e.target.value)}
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            background: 'transparent',
                            zIndex: 4,
                            WebkitAppearance: 'none',
                            height: '40px',
                            pointerEvents: 'none',
                          }}
                        />
                      </div>

                      <span style={{ marginLeft: 8 }}>
                        {Math.min(fractileRange[0], fractileRange[1])}% - {Math.max(fractileRange[0], fractileRange[1])}%
                      </span>


                      <style>{`
    input[type=range] {
      -webkit-appearance: none;
      appearance: none;
      background: transparent;
    }

    input[type=range]::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      height: 16px;
      width: 16px;
      border-radius: 50%;
      background: #FFAA00;
      cursor: pointer;
      pointer-events: auto;
      margin-top: -6px;
      transition: background-color 0.3s;
      position: relative;
    }

    input[type=range]::-webkit-slider-thumb:hover {
      background-color: #FFAA00;
    }

    input[type=range]::-webkit-slider-runnable-track {
      background: transparent;
      height: 6px;
    }
  `}</style>
                    </div> */}
                    <div>
                      <div style={{ position: 'relative', height: '40px', width: '300px' }}>
                        {/* Track background */}
                        <div
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: 0,
                            width: '100%',
                            height: '6px',
                            background: '#ddd',
                            borderRadius: '3px',
                            transform: 'translateY(-50%)',
                            zIndex: 0,
                          }}
                        />

                        {/* Active range fill */}
                        <div
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: `${Math.min(fractileRange[0], fractileRange[1])}%`,
                            width: `${Math.abs(fractileRange[1] - fractileRange[0])}%`,
                            height: '6px',
                            background: '#FFAA00',
                            borderRadius: '3px',
                            transform: 'translateY(-50%)',
                            zIndex: 1,
                          }}
                        />

                        {/* Lower thumb */}
                        <input
                          type="range"
                          min={0}
                          max={100}
                          step={step}
                          value={fractileRange[0]}
                          onChange={e => handleFractileSlider(0, e.target.value)}
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            background: 'transparent',
                            zIndex: 3,
                            WebkitAppearance: 'none',
                            height: '40px',
                            pointerEvents: 'none',
                          }}
                        />

                        {/* Upper thumb */}
                        <input
                          type="range"
                          min={0}
                          max={100}
                          step={step}
                          value={fractileRange[1]}
                          onChange={e => handleFractileSlider(1, e.target.value)}
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            background: 'transparent',
                            zIndex: 4,
                            WebkitAppearance: 'none',
                            height: '40px',
                            pointerEvents: 'none',
                          }}
                        />

                        {/* Numbers above thumbs */}
                        <div
                          style={{
                            position: 'absolute',
                            top: '-18px',
                            left: `${fractileRange[0]}%`,
                            transform: 'translateX(-50%)',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#333',
                          }}
                        >
                          {fractileRange[0]}%
                        </div>
                        <div
                          style={{
                            position: 'absolute',
                            top: '-18px',
                            left: `${fractileRange[1]}%`,
                            transform: 'translateX(-50%)',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#333',
                          }}
                        >
                          {fractileRange[1]}%
                        </div>
                      </div>



                      <style>{`
    input[type=range] {
      -webkit-appearance: none;
      appearance: none;
      background: transparent;
    }

    input[type=range]::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      height: 16px;
      width: 16px;
      border-radius: 50%;
      background: #FFAA00;
      cursor: pointer;
      pointer-events: auto;
      margin-top: -6px;
      transition: background-color 0.3s;
      position: relative;
    }

    input[type=range]::-webkit-slider-thumb:hover {
      background-color: #FFAA00;
    }

    input[type=range]::-webkit-slider-runnable-track {
      background: transparent;
      height: 6px;
    }
  `}</style>
                    </div>


                    {canShowPanIndiaBreakdown && (
                      <div style={styles.marketSizeContainer}>
                        <h3 style={styles.sectionTitle}>Overall Market Size Breakdown (PAN India)</h3>
                        {loading ? (
                          <p style={{ textAlign: 'center', color: '#666' }}>Loading market size data...</p>
                        ) : chartData.length > 0 ? (
                          chartData.map((entry, index) => (
                            <div key={`pan-market-size-entry-${index}`} style={{ marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid #eee' }}>
                              <div style={styles.marketSizeItem}>
                                <span style={styles.marketSizeLabel}>Year:</span>
                                <span>{entry.year}</span>
                              </div>
                              <div style={styles.marketSizeItem}>
                                <span style={styles.marketSizeLabel}>Region Type:</span>
                                <span>{entry.regionType}</span>
                              </div>
                              <div style={styles.marketSizeItem}>
                                <span style={styles.marketSizeLabel}>Fractile Range:</span>
                                <span>{entry.fractileRange}</span>
                              </div>
                              <h4 style={{ fontSize: '13px', fontWeight: '600', marginTop: '10px', marginBottom: '5px', color: '#333' }}>Category Breakdown:</h4>
                              {selectedCategories.map(categoryName => {
                                const value = entry[categoryName];
                                return value !== undefined && value !== null ? (
                                  <div key={categoryName} style={{ ...styles.marketSizeItem, paddingLeft: '15px' }}>
                                    <span style={{ ...styles.marketSizeLabel, fontWeight: 'normal' }}>{categoryName}:</span>
                                    <span>{formatMarketSize(value)}</span>
                                  </div>
                                ) : null;
                              })}
                            </div>
                          ))
                        ) : (
                          <p style={{ textAlign: 'center', color: '#666' }}>
                            No market size data available for the selected PAN India filters.
                          </p>
                        )}
                      </div>
                    )}

                  </div>
                </DrawerBody>
              </DrawerContent>
            </Drawer>
          </Box>
        )}


      </Flex>

      {/* Bottom Section */}
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="flex-start"
        align="flex-start"
        w="100%"
        p={3}
        gap={6}
      >
        {/* Global Export */}
        <Box
          flex="1"
          h={{ base: "auto", md: "403px" }}
          overflowY={{ base: "visible", md: "auto" }}
          scrollBehavior="smooth"
          borderRadius="8px"
          sx={{
            "&::-webkit-scrollbar": { width: "8px" },
            "&::-webkit-scrollbar-track": { background: "#f1f1f1", borderRadius: "8px" },
            "&::-webkit-scrollbar-thumb": { background: "#30D5C8", borderRadius: "8px" },
            "&::-webkit-scrollbar-thumb:hover": { background: "#25b9ad" },
          }}
        >
          <Box h={{ base: "auto", md: "403px" }}>
            <GlobalExport
              sectorName={sectorName}
              onProductSelect={setSelectedProduct}
              sectorWiseCategories={sectorWiseCategories}
              categories={categories}
            />
          </Box>
        </Box>

        {/* Export Graph */}
        <Box
          flex="1"
          h={{ base: "auto", md: "403px" }}
          // overflowY={{ base: "visible", md: "auto" }}
          scrollBehavior="smooth"
          borderRadius="8px"
          sx={{
            "&::-webkit-scrollbar": { width: "8px" },
            "&::-webkit-scrollbar-track": { background: "#f1f1f1", borderRadius: "8px" },
            "&::-webkit-scrollbar-thumb": { background: "#30D5C8", borderRadius: "8px" },
            "&::-webkit-scrollbar-thumb:hover": { background: "#25b9ad" },
          }}
        >
          <Box h={{ base: "auto", md: "403px" }}>
            <ExportDataGraph
              title="Top Markets to Export"
              sectorName={sectorName}
              selectedProduct={selectedProduct}
              sectorWiseCategories={sectorWiseCategories}
              categories={categories}
            />
          </Box>
        </Box>
      </Flex>
    </>
  );




};

export default CategorySize;











